<template src="./template.html"></template>

<script>
import { Fragment } from 'vue-fragment'

import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import SubmitButton from '@/components/Button/index.vue'
import LocationFormInput from '@/components/Form/Input/index.vue'
import LocationForm from '@/components/Form/index.vue'
import LoadingSpinner from '@/components/LoadingSpinner'
import SectionHeader from '@/components/SectionHeader/index.vue'
import DumpingStationTable from '@/components/Table/index.vue'
import CompanyNav from '@/components/company_nav'
import GeoCoder from '@/components/geocoder'

import locationsApi from '@/api/locations'

export default {
  name: 'company_location',
  inject: ['showPopup'],
  data() {
    return {
      company: {},
      dumpingStations: [],
      loading: true,
      location: {},
      templateMode: 'edit',
    }
  },
  components: {
    BreadCrumbs,
    SubmitButton,
    CompanyNav,
    DumpingStationTable,
    LocationForm,
    LocationFormInput,
    Fragment,
    GeoCoder,
    LoadingSpinner,
    SectionHeader,
  },
  methods: {
    getCoordinates(value) {
      this.location.lat = value[1]
      this.location.lng = value[0]
    },
    async onFormSubmitted() {
      await this.updateLocation()
    },
    async updateLocation() {
      const updatedLocation = await locationsApi.update(this.$route.params.location_uuid, this.location)
      if (updatedLocation) {
        this.location = updatedLocation
      }
    },
    async deleteDumpingStation(uuid) {
      if (await this.showPopup({ content: this.$t('companies.deleteDumpingStationConfirmation'), type: 'confirm' })) {
        await locationsApi.deleteDumpingStation(this.$route.params.location_uuid, uuid)
        this.dumpingStations = await locationsApi.getDumpingStations(this.$route.params.location_uuid)
      }
    },
    async deleteLocation(uuid) {
      if (await this.showPopup({ content: this.$t('companies.deleteLocationConfirmation'), type: 'confirm' })) {
        const response = await locationsApi.delete(uuid)
        if (response) {
          await this.$router.push('/company')
        }
      }
    },
  },
  async mounted() {
    // prettier-ignore
    [this.location, this.dumpingStations] = await Promise.all([
      locationsApi.get(this.$route.params.location_uuid),
      locationsApi.getDumpingStations(this.$route.params.location_uuid),
    ])
    this.loading = false
  },
}
</script>
